import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'

import { NoImageContentProps } from '../../../core/types/Help'

export const NoImageContent: React.FC<NoImageContentProps> = ({
  content,
  hasDivider = true,
  sx,
}) => {
  return (
    <>
      <Box sx={{ pb: 48, ...sx }}>{content}</Box>
      {hasDivider && <Divider />}
    </>
  )
}
